import { j as o } from "../../utils-BdNIfrGQ.js";
import { useState as g, useEffect as E } from "react";
import { createPortal as F } from "react-dom";
import { a as y } from "../../Button-CzIiGCVn.js";
import { D as M, d as O, e as P, f as z, h as B } from "../../dialog-C3hgj4md.js";
import { S as A } from "../../Switch-DO4qcPoG.js";
function f(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var d in r)
      d !== "__proto__" && (e[d] = r[d]);
  }
  return e;
}
var I = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function C(e, t) {
  function r(n, c, a) {
    if (!(typeof document > "u")) {
      a = f({}, t, a), typeof a.expires == "number" && (a.expires = new Date(Date.now() + a.expires * 864e5)), a.expires && (a.expires = a.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var i = "";
      for (var l in a)
        a[l] && (i += "; " + l, a[l] !== !0 && (i += "=" + a[l].split(";")[0]));
      return document.cookie = n + "=" + e.write(c, n) + i;
    }
  }
  function d(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var c = document.cookie ? document.cookie.split("; ") : [], a = {}, i = 0; i < c.length; i++) {
        var l = c[i].split("="), m = l.slice(1).join("=");
        try {
          var u = decodeURIComponent(l[0]);
          if (u in a || (a[u] = e.read(m, u)), n === u)
            break;
        } catch {
        }
      }
      return n ? a[n] : a;
    }
  }
  return Object.create(
    {
      set: r,
      get: d,
      remove: function(n, c) {
        r(
          n,
          "",
          f({}, c, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return C(this.converter, f({}, this.attributes, n));
      },
      withConverter: function(n) {
        return C(f({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var N = C(I, { path: "/" });
const L = "_c", V = {
  expires: 365,
  path: "/"
}, U = () => ({
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied"
}), R = () => {
  const e = window;
  e.gtag || (e.dataLayer = e.dataLayer || [], e.gtag = function(...r) {
    e.dataLayer.push(r);
  });
}, D = (e) => {
  R();
  const t = window;
  t.gtag("consent", "update", e), t.dataLayer.push({
    event: "gtm_consent_update",
    ...e
  });
}, te = () => {
  R(), window.gtag("consent", "default", U());
}, w = (e) => e ? "granted" : "denied", S = (e) => {
  const [, t, r] = e.split(";").map((d) => d === "1");
  return {
    ad_storage: w(r),
    ad_user_data: w(r),
    ad_personalization: w(r),
    analytics_storage: w(t)
  };
}, j = () => N.get(L), ae = () => {
  const e = j();
  return e ? e.split(";")[1] === "1" : !1;
}, $ = (e) => {
  N.set(L, e, V);
}, G = ({
  analyticsAllowed: e,
  marketingAllowed: t
}) => `1;${e ? "1" : "0"};${t ? "1" : "0"}`, W = (e) => {
  const t = G(e);
  $(t), D(S(t));
}, ne = () => {
  const e = j();
  e && D(S(e));
}, Y = {
  bodyText: "At Race Roster, your peace of mind is our priority. We care about your privacy and we respect how your data is used. Together with our partners, we use cookies to improve your experience on our site and how we communicate with you. We aim to analyze how our site performs, deliver tailored advertising content on this and other sites and gain your feedback. By clicking “Accept All Cookies” you agree to the use of such cookies. To change your cookie settings, click “Manage Cookies” to visit our Cookie Preference Center. For more information about our data practices, please read our",
  cookiePolicyLink: "Cookie Policy",
  privacyPolicyLink: "Privacy Policy",
  manageCookies: "Manage Cookies",
  reject: "Reject Non-Functional Cookies",
  accept: "Accept All Cookies",
  ariaLabel: "Cookie consent"
}, x = {
  title: "Manage Cookies",
  cancel: "Cancel",
  save: "Save & Accept",
  moreInfo: "More information",
  analyticsToggle: "Activate analytical cookies",
  marketingToggle: "Activate marketing cookies",
  tabs: {
    privacy: {
      label: "Your privacy",
      content: "We value the trust that you place in Race Roster by sharing your personal data with us and we are committed to handling your personal data in a way that is fair and worthy of that trust. Therefore, please keep in mind that when you visit our site, we and third parties may store or retrieve information on your browser, mostly in the form of cookies. However, you can learn more about cookies and exercise choice regarding non-essential cookies by navigating the sections above. We encourage you to click on the different sections above to access a description of each category and to choose your settings for our site. Your settings do not automatically apply to all Race Roster sites you visit, and you must set your choices on each browser and device you use. If you block or clear cookies on your device you may lose your Race Roster settings. For more information, including other ways to control cookies, please also read our Privacy Policy and Cookie Policy."
    },
    functional: {
      label: "Functional",
      content: "These cookies are necessary for the website to function properly and are therefore set to “always active”. They are often set in response to actions made by you which amount to a request for services, such as setting your (privacy) preferences, remembering items in your shopping cart, logging in or completing forms. You can set your browser to block or alert you about these cookies, but some parts of the website will not then work."
    },
    analytics: {
      label: "Performance & Analytics",
      content: "These cookies allow us to measure and analyze our website audience so we can improve the performance of our sites. They help us to know which pages are the most and least popular and see how visitors move around the website. They also allow us to improve the speed with which we can process your request, allowing us to remember the website preferences you have selected. It also helps identify issues faced by users on the website. Not allowing these cookies may result in poorly-tailored recommendations and slow site preferences."
    },
    marketing: {
      label: "Targeting, Marketing & Social Media",
      content: "These cookies allow us to make your user experience more personal and to recommend certain products. We do this, among other things, based on your behavior on the Race Roster website across the various devices you use. Furthermore, these cookies collect information to tailor advertising to your interest. They can be set by us or by our advertising partners. They may be used to build a profile of your interests and show you relevant advertising on our websites or on other websites. If you do not allow these cookies, you will experience less targeted advertising. Social Media cookies offer the possibility to connect you to your social networks (Facebook, Twitter, Instagram, YouTube and LinkedIn) and share content from our website through social media."
    }
  }
};
let T = !1;
const q = (e) => {
  if (T) return;
  T = !0;
  const t = window;
  t.dataLayer = t.dataLayer || [], t.dataLayer.push({ "gtm.start": (/* @__PURE__ */ new Date()).getTime(), event: "gtm.js" });
  const r = document.createElement("script");
  r.async = !0, r.src = `https://www.googletagmanager.com/gtm.js?id=${e}`, document.head.appendChild(r);
}, H = ["privacy", "functional", "analytics", "marketing"], K = ({
  open: e,
  onClose: t,
  onSave: r,
  cookiePolicyUrl: d,
  labels: n
}) => {
  const c = { ...x, ...n }, a = { ...x.tabs, ...n?.tabs }, [i, l] = g("privacy"), [m, u] = g(!0), [p, h] = g(!0), k = (s) => a[s]?.label ?? x.tabs[s].label, b = (s) => a[s]?.content ?? x.tabs[s].content, v = () => {
    r({ analyticsAllowed: m, marketingAllowed: p });
  };
  return /* @__PURE__ */ o.jsx(M, { open: e, onOpenChange: (s) => !s && t(), children: /* @__PURE__ */ o.jsxs(
    O,
    {
      className: "w-[90vw] max-w-[680px] max-h-[80vh] flex flex-col gap-0 p-0",
      showCloseButton: !1,
      "aria-labelledby": "manage-cookies-title",
      children: [
        /* @__PURE__ */ o.jsx(P, { className: "px-10 pt-8 pb-0", children: /* @__PURE__ */ o.jsx(z, { id: "manage-cookies-title", className: "text-xl", children: c.title }) }),
        /* @__PURE__ */ o.jsx("div", { className: "mt-4 flex overflow-x-auto border-b border-border px-10", role: "tablist", children: H.map((s) => /* @__PURE__ */ o.jsx(
          "button",
          {
            type: "button",
            role: "tab",
            "aria-selected": i === s,
            "aria-controls": `tab-panel-${s}`,
            className: `whitespace-nowrap border-b-2 px-4 py-3 text-sm transition-colors cursor-pointer ${i === s ? "border-primary text-primary font-medium" : "border-transparent text-muted-foreground hover:text-foreground"}`,
            onClick: () => l(s),
            children: k(s)
          },
          s
        )) }),
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            className: "flex-1 overflow-y-auto px-10 py-8 text-sm leading-relaxed text-muted-foreground min-h-[180px]",
            role: "tabpanel",
            id: `tab-panel-${i}`,
            children: [
              /* @__PURE__ */ o.jsx("p", { children: b(i) }),
              i === "analytics" && /* @__PURE__ */ o.jsx("div", { className: "mt-5 pt-4", children: /* @__PURE__ */ o.jsx(
                A,
                {
                  id: "analytics-toggle",
                  label: c.analyticsToggle,
                  variant: "primary",
                  checked: m,
                  onCheckedChange: u
                }
              ) }),
              i === "marketing" && /* @__PURE__ */ o.jsx("div", { className: "mt-5 pt-4", children: /* @__PURE__ */ o.jsx(
                A,
                {
                  id: "marketing-toggle",
                  label: c.marketingToggle,
                  variant: "primary",
                  checked: p,
                  onCheckedChange: h
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ o.jsxs(B, { className: "flex-row items-center border-t border-border px-10 py-6", children: [
          /* @__PURE__ */ o.jsx(
            "a",
            {
              className: "mr-auto text-sm text-primary underline underline-offset-4 hover:text-primary/80",
              href: d,
              target: "_blank",
              rel: "noopener noreferrer",
              children: c.moreInfo
            }
          ),
          /* @__PURE__ */ o.jsx(y, { variant: "outline", size: "sm", onClick: t, children: c.cancel }),
          /* @__PURE__ */ o.jsx(y, { variant: "default", size: "sm", onClick: v, children: c.save })
        ] })
      ]
    }
  ) });
}, _ = "text-primary underline underline-offset-2 hover:text-primary/80", re = ({
  gtmContainerId: e,
  cookiePolicyUrl: t,
  privacyPolicyUrl: r,
  onConsentApplied: d,
  bannerLabels: n,
  dialogLabels: c
}) => {
  const a = { ...Y, ...n }, [i, l] = g(!1), [m, u] = g(!1);
  E(() => {
    j() || l(!0);
  }, []);
  const p = () => l(!1), h = (s) => {
    W(s), q(e), d?.(s);
  }, k = () => {
    h({ analyticsAllowed: !0, marketingAllowed: !0 }), p();
  }, b = () => {
    h({ analyticsAllowed: !1, marketingAllowed: !1 }), p();
  }, v = (s) => {
    h(s), u(!1), p();
  };
  return i ? F(
    /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx(
        "div",
        {
          className: "fixed inset-x-0 bottom-0 z-[9999] bg-background shadow-[0_-4px_12px_rgba(0,0,0,0.15)] animate-in slide-in-from-bottom duration-300",
          role: "region",
          "aria-label": a.ariaLabel,
          children: /* @__PURE__ */ o.jsxs("div", { className: "mx-auto max-w-[1200px] px-8 py-6 max-md:px-5 max-md:py-4", children: [
            /* @__PURE__ */ o.jsxs("p", { className: "mb-5 text-[13px] leading-relaxed text-muted-foreground", children: [
              a.bodyText,
              " ",
              /* @__PURE__ */ o.jsx(
                "a",
                {
                  className: _,
                  href: t,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: a.cookiePolicyLink
                }
              ),
              " ",
              "and",
              " ",
              /* @__PURE__ */ o.jsx(
                "a",
                {
                  className: _,
                  href: r ?? t,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: a.privacyPolicyLink
                }
              ),
              "."
            ] }),
            /* @__PURE__ */ o.jsxs("div", { className: "flex flex-wrap items-center gap-6 max-md:flex-col", children: [
              /* @__PURE__ */ o.jsx(y, { variant: "link", size: "sm", onClick: () => u(!0), children: a.manageCookies }),
              /* @__PURE__ */ o.jsxs("div", { className: "ml-auto flex flex-wrap items-center gap-4 max-md:ml-0 max-md:w-full max-md:flex-col", children: [
                /* @__PURE__ */ o.jsx(y, { variant: "outline", size: "sm", onClick: b, children: a.reject }),
                /* @__PURE__ */ o.jsx(y, { variant: "default", size: "sm", onClick: k, children: a.accept })
              ] })
            ] })
          ] })
        }
      ),
      /* @__PURE__ */ o.jsx(
        K,
        {
          open: m,
          onClose: () => u(!1),
          onSave: v,
          cookiePolicyUrl: t,
          labels: c
        }
      )
    ] }),
    document.body
  ) : null;
};
export {
  L as CONSENT_COOKIE_NAME,
  re as CookieConsentBanner,
  Y as DEFAULT_BANNER_LABELS,
  x as DEFAULT_DIALOG_LABELS,
  K as ManageCookiesDialog,
  W as applyConsentPreferences,
  G as buildConsentCookieValue,
  j as getConsentCookieValue,
  w as getConsentValue,
  ae as isAnalyticalAllowed,
  q as loadGTMScript,
  S as parseConsentCookie,
  $ as setConsentCookieValue,
  te as setDefaultGTMConsent,
  ne as updateConsentFromCookie,
  D as updateGTMConsent
};
